type Clonable =
  | string
  | number
  | boolean
  | null
  | undefined
  | Date
  | Map<unknown, unknown>
  | Set<unknown>
  | Clonable[]
  | object
  | { [key: string]: Clonable };

export function deepCopy<T extends Clonable>(object: T): T {
  if (typeof structuredClone === 'function') {
    return structuredClone(object);
  }

  try {
    return JSON.parse(JSON.stringify(object)) as T;
  } catch (error) {
    if (object instanceof Map) {
      return new Map(deepCopy(Array.from(object.entries()))) as T;
    }
    if (object instanceof Set) {
      return new Set(deepCopy(Array.from(object))) as T;
    }
    if (object instanceof Date) {
      return new Date(object.getTime()) as T;
    }
    if (Array.isArray(object)) {
      return object.map((item) => deepCopy(item)) as T;
    }
    if (object !== null && typeof object === 'object') {
      const clonedObject: { [key: string]: Clonable } = {};
      Object.keys(object).forEach((key) => {
        clonedObject[key] = deepCopy((object as { [key: string]: Clonable })[key]);
      });
      return clonedObject as T;
    }
    if (object === undefined) {
      return undefined as T;
    }
    if (object === null) {
      return null as T;
    }

    throw new Error('Unable to clone data');
  }
}
